import axios from 'axios'

const ApplyNowLogo = () => {
    return axios.get('/logo-apply-now', {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'image/png',
        }
    })
    .then( response => {
        if( response.status === 200 ){
            return response.data
        }else{
            throw new Error(`GET /apply-now-js responded with status ${response.status}`)
        }
    })
    .then( res => {
        if (res) {
            function _arrayBufferToBase64( buffer ) {
              var binary = '';
              var bytes = new Uint8Array( buffer );
              var len = bytes.byteLength;
              for (var i = 0; i < len; i++) {
                binary += String.fromCharCode( bytes[ i ] );
              }
              return window.btoa( binary );
            }
            let img = _arrayBufferToBase64(res);
            return img
          }
    })
    .catch(function (error) {
        // TODO: come up with a error handling solution
        // maybe integrate with airbrake
        console.log( `ERROR : ${error}` )
    });
}   

export default ApplyNowLogo

//   }